import { render, staticRenderFns } from "./AppClamp2.vue?vue&type=template&id=6f9c25a4&"
import script from "./AppClamp2.vue?vue&type=script&lang=js&"
export * from "./AppClamp2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports